let dd = require("ES/lib/dd");
let Modal = require("ES/widgets/Modal");

module.exports = dd.createClass({
	render() {
		let {
			onClose
		} = this.props;

		return Modal({
				title: "Redacted Contact in Messages",
				buttons: [],
				onClose
			},
			dd.div({className: "row"},
				dd.div({className: "col-sm-3 text-center text-muted"},
					dd.i({className: "fa fa-warning", style: {fontSize: 60}})
				),
				dd.div({className: "col-sm-9"},
					dd.p(null,
						"Did you notice the ░░░'s? The message contains direct contact information that was removed from the message."
					),
                    dd.p(null,
                        "We encourage direct contact after an offer has been agreed to and a deposit paid, but until then we ask that you use only our messaging to communicate with the buyer."
					),
                    dd.p(null,
                        dd.b(null, dd.i(null, "Once an agreement is signed, the buyer will be given your direct contact information and can communicate with you directly."))
                    ),
                    dd.p(null,
                        "Direct communication prior to an agreement tends to take jobs out of the system and hurts everyone."
					),
					dd.br()
				)
			),
			dd.div({className: "text-center"},
					dd.button({className: "btn btn-primary", onClick: onClose}, "Close")
			)
		);
	}
});


// WEBPACK FOOTER //
// ./src/components/modals/MessageWithRedactedContact.js